import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen.ts';

// One QueryClient per app — used for all /auth/me, /domains, /issues etc. fetches.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 min — most data is rarely-changing dashboard state
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// `context` is plumbed through to every route's beforeLoad / loader / component
// via `Route.useRouteContext()`. The pathless `_authenticated` layout uses
// `context.queryClient` to fetch + cache the /auth/me result.
const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: { queryClient },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
